/**
 * @generated SignedSource<<30f48154813a03ac1c6a70e483bd1e83>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationPushAppyScreenDeleteMutation$variables = Record<PropertyKey, never>;
export type IntegrationPushAppyScreenDeleteMutation$data = {
  readonly store: {
    readonly deleteIntegrationPushAppy: boolean | null;
  };
};
export type IntegrationPushAppyScreenDeleteMutation = {
  response: IntegrationPushAppyScreenDeleteMutation$data;
  variables: IntegrationPushAppyScreenDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleteIntegrationPushAppy",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationPushAppyScreenDeleteMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "IntegrationPushAppyScreenDeleteMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "1b1434ed63775a348e51b6cd59b89dfd",
    "id": null,
    "metadata": {},
    "name": "IntegrationPushAppyScreenDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationPushAppyScreenDeleteMutation {\n  store {\n    deleteIntegrationPushAppy\n  }\n}\n"
  }
};
})();

(node as any).hash = "4c148eda4e923c9f23890ce10b101e10";

export default node;
